import type { FunctionComponent, ReactNode, SVGProps } from 'react'
import { FormattedMessage } from 'react-intl'

import { Divider } from '@gto/ui/divider'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import type { Translations } from '@/localise'

import { BenefitIcon } from './benefit-icon'

export type HowToItem = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>
  title: keyof Translations
  description: keyof Translations
  order: number
  children?: ReactNode
  placement?: 'left' | 'center'
}
export const PromoHowToCard = ({
  icon: Icon,
  title,
  description,
  children,
  order,
  placement = 'left',
}: HowToItem) => {
  return (
    <Paper
      className="flex h-full flex-col gap-3 rounded-md border border-divider p-5"
      elevation="1"
    >
      <div className="flex items-start justify-between">
        <div
          className={
            placement === 'left'
              ? 'flex flex-[1_0_auto] items-center justify-start gap-3'
              : 'flex flex-[1_0_auto] items-center justify-center gap-3'
          }
        >
          <BenefitIcon>
            <Icon
              height={28}
              width={28}
            />
          </BenefitIcon>
          <Typography
            color="primary"
            variant="h6"
          >
            <FormattedMessage id={title} />
          </Typography>
        </div>
        <Typography
          className="leading-[1]"
          color="primary"
          variant="subtitle1"
        >
          {order}
        </Typography>
      </div>
      <Typography
        color="text.secondary"
        style={{ textAlign: placement }}
        variant="subtitle1"
      >
        <FormattedMessage id={description} />
      </Typography>
      {children !== undefined && (
        <>
          <Divider flexItem />
          {children}
        </>
      )}
    </Paper>
  )
}
